import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import { FindUs, Footer, Header, SpecialMenu } from "./container";
import { Navbar } from "./components";
import "./App.css";

const App = () => {
  const [showScrollTopButton, setShowScrollTopButton] = useState(false);

  useEffect(() => {
    // Function to check scroll position
    const checkScrollTop = () => {
      // Show button if page is scrolled more than 400px
      if (!showScrollTopButton && window.scrollY > 400) {
        setShowScrollTopButton(true);
      } else if (showScrollTopButton && window.scrollY <= 400) {
        setShowScrollTopButton(false);
      }
    };

    // Add event listener
    window.addEventListener("scroll", checkScrollTop);

    // Cleanup function to remove listener
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [showScrollTopButton]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <Navbar />
      <Header />
      <SpecialMenu />
      <FindUs />
      <Footer />
      <button
          onClick={scrollTop}
          className={`scrollTopButton ${showScrollTopButton ? "scrollTopButton--visible" : ""}`}
          aria-label="Scroll to top"
        >
          <FaArrowUp />
        </button>
    </div>
  );
};

export default App;
